import { DivisionType } from 'models/common'

export const divisionLabels: Record<DivisionType, string> = {
  [DivisionType.M]: 'Главный банк',
  [DivisionType.B]: 'Филиал',
}
